<template>
  <form @submit.prevent="submit">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Create Service Level</p>
      </header>
      <section class="modal-card-body">
        <!-- <base-select
          :service="$options.associatedService"
          fetch-func="firmFirm"
          :fetch-params="{
            parent_id: organization ? organization.id : undefined,
            includes: 'firm'
          }"
          label="Firm"
          :value.sync="data.firm_firm_id"
          label-key="firm.name"
          v-if="organization"
        >
          <template #defaultOptionLabel>Select firms</template>
        </base-select> -->

        <base-select
          :service="$options.codeService"
          fetch-func="all"
          :fetch-params="{
            contract_id: contractId || undefined,
            firm_id: $store.state.Auth.user.firmId,
            type: 'orderPriority'
          }"
          label="Priority"
          :value.sync="data.priority_code_id"
        />

        <b-field label="Start by hours">
          <b-input type="text" v-model="data.hours_to_start"></b-input>
        </b-field>
        <b-field label="Finish by hours">
          <b-input type="text" v-model="data.hours_to_finish"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button class="button is-primary" :disabled="loading">Create</button>
      </footer>
    </div>
  </form>
</template>
<script>
import { ServiceLevelService } from "@/services/serviceLevel.service";
import { AssociatedService } from "@/services/associated.service";
import { CodeService } from "@/services/code.service";
import BaseSelect from "@/components/partials/BaseSelect";

export default {
  associatedService: AssociatedService,
  codeService: CodeService,
  props: {
    organization: {
      type: Object
    },
    contractId: {
      type: [String, Number],
    },
  },
  data: () => ({
    serviceLevelService: ServiceLevelService,
    data: {
      firm_firm_id: null,
      priority_code_id: null,
      hours_to_start: null,
      hours_to_finish: null
    },
    loading: false
  }),

  components: {
    BaseSelect
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        const serviceLevel = await this.serviceLevelService.create({
          ...this.data,
          firm_firm_id: this.data.firm_firm_id || undefined,
          contract_id: this.contractId || undefined,
        });
        this.$emit('create');
        this.loading = false;
        this.$parent.close();
      } catch (err) {
        this.loading = false;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/ServiceLevels/list/partials/createServiceLevelModal.vue